import { Stack } from 'commons/components';
import ShippingDisponibilityCard from '../../../components/ShippingDisponibilityCard';
import ShippingMethodsScopeCard from '../../../components/ShippingMethodsScopeCard';
import ShippingRestrictionsCard from '../../../components/ShippingRestrictionsCard';

function Skeleton(): JSX.Element {
  return (
    <Stack column align="stretch" spacing="base">
      <ShippingMethodsScopeCard.Skeleton />
      <ShippingDisponibilityCard.Skeleton />
      <ShippingRestrictionsCard.Skeleton />
    </Stack>
  );
}

export default Skeleton;
